export default "__VITE_ASSET__D7lNQV9S__"